// UUID helper for browsers (production-safe)
export function generateUserId() {
  // Modern browsers
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback (non-cryptographic, but stable-enough for local dev)
  const rand = () => Math.random().toString(16).slice(2);
  return `uid_${Date.now().toString(16)}_${rand()}_${rand()}`;
}

